import React from "react";

export default function Footer() {
    // Mendapatkan tahun saat ini
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="container">
                {/* Quick Links, Navigation, dan Contact Us */}
                <div className="footer-top">
                    <div className="footer-section">
                        <h4>Quick Links</h4>
                        <ul>
                            <li><a href="#hero">Home</a></li>
                            <li><a href="#about">About Us</a></li>
                            <li><a href="#services">Our Services</a></li>
                            <li><a href="#contact">Contact Us</a></li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h4>Navigation</h4>
                        <ul>
                            <li><a href="#vision-mission">Vision & Mission</a></li>
                            <li><a href="#background">Background</a></li>
                            <li><a href="#portfolio">Portfolio</a></li>
                            <li><a href="/works">Works</a></li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h4>Contact Us</h4>
                        <p>Email: info@innovatech.co.id</p>
                        <p>Phone: +62 857-2777-9779</p>
                        <p>Address: Jakarta, Indonesia</p>
                    </div>
                </div>

                {/* Copyright dan Social Icons */}
                <div className="footer-bottom">
                    <p className="copyright-text">&copy; {currentYear} PT. Innovatech Digi Eravision. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
}